import React from 'react';
import { slugify } from '../../../utils/helpers'

export const Select = (props) => {
  const { field, value, filter, handleChange } = props
  const {type, name, filter: fieldFilter, placeholder, required, className, options = {} } = field
  if (fieldFilter && fieldFilter.length > 0 && !fieldFilter.includes(filter)) return null;
  return (
    <div className={`${className}${value[slugify(name)] ? ' active' : ''}${required ? ' required' : ''}`}>
      <label htmlFor={name}>{placeholder}</label>
      <select name={name} id={name} placeholder={placeholder} required={required ? true : false} defaultValue="" onChange={handleChange} value={value[slugify(name)]}>
        {placeholder ? <option disabled value="">{placeholder}</option> : null}
        {options && options.filter(option => !option.filter || option.filter.includes(filter)).map((option, index) => (
          <option key={index} value={slugify(option.value)}>{option.label}</option>
        ))}
      </select>
    </div>
  )
}
